import React from "react";
import { Star } from "lucide-react";

const TutorCard = ({ tutor, onClick, isSelected = false }) => {
  return (
    <div
      className={`bg-white rounded-2xl p-6 shadow-md border border-gray-200 transition-all cursor-pointer hover:shadow-lg ${
        isSelected ? "ring-2 ring-blue-400" : ""
      }`}
      onClick={onClick}
    >
      <div className="flex gap-4">
        <img
          src={tutor.image}
          alt={tutor.name}
          className="w-24 h-24 object-cover rounded-xl"
        />

        <div className="flex flex-col flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              {tutor.name}
            </h3>
            <span className="text-gray-500 text-lg">›</span>
          </div>

          <div className="flex items-center gap-2 text-gray-700 text-sm mt-1">
            <Star size={16} className="text-yellow-500" />
            <span>{tutor.rating} ({tutor.reviews})</span>
            <span>•</span>
            <span>{tutor.experience}</span>
          </div>

          <p className="text-gray-600 text-sm mt-2">
            {tutor.description}
          </p>

          <div className="flex gap-2 mt-3">
            {tutor.years.map((year, i) => (
              <span
                key={i}
                className="px-3 py-1 bg-gray-100 border border-gray-300 rounded-full text-xs"
              >
                {year}
              </span>
            ))}
          </div>

          <p className="mt-3 text-[#08A595] font-semibold">
            ${tutor.price}/hr
          </p>
        </div>
      </div>
    </div>
  );
};

export default TutorCard;